































import { Component, Vue } from 'vue-property-decorator';

import { logout } from '@/utils/api';

@Component({
  name: 'topUser',
  components: {},
})
export default class TopUser extends Vue {
  resetPasswordVisible: boolean = false;
  showCancel:boolean = false
  dropdownMenuShow: boolean = false;

  get userInfo() {
    return this.$store.state.userInfo;
  }
  /*
   *@description:'修改密码成功'
   */
  updatePassWordSuccess() {
    console.log('修改密码成功');
    this.$message.success('修改成功!');
    localStorage.removeItem('authToken');
    location.href = '/login';
  }

    // 记录下拉菜单是否显示
  dropdownChange(val) {
    this.dropdownMenuShow = val
  }

  updatePassWord() {
    this.showCancel = true
    this.resetPasswordVisible = true;
  }

  logout() {
    this.$store.commit('CLOSETAllSS');
    logout()
      .then((res) => {
        localStorage.removeItem('authToken');
        location.href = '/login';
      })
      .catch((error) => {
        this.$message.error('退出失败');
      });
  }
}
